module.exports = __webpack_public_path__ + "assets/img/img90.0429b6db.png";